import produce from 'immer';
import initialState from '../initialState/versionHistory';
import * as versionHistoryActionTypes from '../../constants/actionTypes/versionHistory';

const versionHistory = (state = initialState, action) => produce(state, (draftState) => {
    switch (action.type) {
        case versionHistoryActionTypes.UPDATE_VERSION_HISTORY:
            draftState.versionHistory = draftState.versionHistory.concat(action.payload.items);
            draftState.isVersionHistoryLoaded = true;
            break;
        case versionHistoryActionTypes.CLEAR_VERSION_HISTORY:
            draftState.versionHistory = [];
            draftState.isVersionHistoryLoaded = false;
            break;
        case versionHistoryActionTypes.UPDATE_VERSION_HISTORY_ITEM_LOADED_STATUS:
            draftState.versionHistoryItem = {};
            draftState.isVersionHistoryItemLoaded = action.payload;
            break;
        case versionHistoryActionTypes.UPDATE_VERSION_HISTORY_ITEM:
            draftState.versionHistoryItem = action.payload;
            draftState.isVersionHistoryItemLoaded = true;
            break;
        case versionHistoryActionTypes.UPDATE_VERSION_HISTORY_ITEM_SAVING_STATUS:
            draftState.isVersionHistoryItemSaving = action.payload.isSaving;
            break;
        case versionHistoryActionTypes.UPDATE_VERSION_HISTORY_LATEST_SAVED_ITEM: {
            if (action.payload.versionID && draftState.rejectedVersionIDs.includes(action.payload.versionID)) {
                break;
            }
            const pending = draftState.pendingVersionHistorySave;
            // A refetch can return this client's own unconfirmed item; keep it marked as pending.
            const isPendingItem = pending && action.payload.versionID && action.payload.versionID === pending.versionID;
            draftState.latestVersionHistorySavedItem = isPendingItem
                ? { ...action.payload, pendingSaveId: pending.pendingSaveId }
                : action.payload;
            break;
        }
        case versionHistoryActionTypes.SET_VERSION_HISTORY_PENDING_SAVED_ITEM: {
            const pending = draftState.pendingVersionHistorySave;
            // A save retried before any reply still reverts to the last confirmed item.
            const stillPending =
                pending && draftState.latestVersionHistorySavedItem.pendingSaveId === pending.pendingSaveId;
            draftState.pendingVersionHistorySave = {
                pendingSaveId: action.payload.pendingSaveId,
                versionID: action.payload.versionID,
                previous: stillPending ? pending.previous : draftState.latestVersionHistorySavedItem,
            };
            draftState.latestVersionHistorySavedItem = action.payload;
            break;
        }
        case versionHistoryActionTypes.TRACK_VERSION_HISTORY_PENDING_SAVE:
            // A save that writes no version history item still needs its reply to be recognised.
            if (!draftState.pendingVersionHistorySave) {
                draftState.pendingVersionHistorySave = {
                    pendingSaveId: action.payload,
                    versionID: undefined,
                    previous: draftState.latestVersionHistorySavedItem,
                };
            }
            break;
        case versionHistoryActionTypes.CONFIRM_VERSION_HISTORY_PENDING_SAVED_ITEM: {
            const pending = draftState.pendingVersionHistorySave;
            // Integrations that do not echo the id confirm whatever is pending.
            if (pending && (!action.payload || action.payload === pending.pendingSaveId)) {
                if (pending.versionID) {
                    // This version is saved after all, so it is no longer rejected.
                    draftState.rejectedVersionIDs = draftState.rejectedVersionIDs.filter(
                        (versionID) => versionID !== pending.versionID
                    );
                }
                draftState.pendingVersionHistorySave = null;
            }
            break;
        }
        case versionHistoryActionTypes.REVERT_VERSION_HISTORY_PENDING_SAVED_ITEM: {
            const pending = draftState.pendingVersionHistorySave;
            // A reply for an older save must not undo a newer pending one.
            if (!pending || (action.payload && action.payload !== pending.pendingSaveId)) {
                break;
            }
            // Undo only this client's pending item; a newer item (e.g. a remote save) stays.
            if (draftState.latestVersionHistorySavedItem.pendingSaveId === pending.pendingSaveId) {
                draftState.latestVersionHistorySavedItem = pending.previous;
            }
            if (pending.versionID && !draftState.rejectedVersionIDs.includes(pending.versionID)) {
                // Keep every rejected version marked; a refetch for any of them may still be in flight.
                draftState.rejectedVersionIDs = [...draftState.rejectedVersionIDs.slice(-19), pending.versionID];
            }
            draftState.pendingVersionHistorySave = null;
            break;
        }
        default:
    }
});

export default versionHistory;
